import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import Carousel from 'react-material-ui-carousel'
import './ImageSlides.scss';
import { http, general, AlertService } from '../../fx-core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const ImageSlides = (props: any) => {

    const initialList = [];
    const [items, setItems] = useState(initialList);
    const [currentContext, setCurrentContext] = useState(props.imageConfig);
    const [selectedIndex, setSelectedIndex] = useState(0);


    const zoomRef = React.useRef<any>(null);

    const handleChange = (selectedIdx) => {
    setSelectedIndex(selectedIdx);
    // Reset zoom/pan when slide changes
    if (zoomRef.current?.resetTransform) {
        zoomRef.current.resetTransform();
    }
    };

    
    const getImages = () => {
        let apiOptions: any = {
            url: currentContext.api
        };
        http.post(apiOptions).then(response => {
            let result = response.data;
            for (let item of result) {
                item.imageUrl = general.getImageUrl(item.imagePath);
            }
            setItems(result);
        });
    }

    const handleClose = () => {
        props.handleImageSlideClose();
    }

    const deleteImage = () => {
        let item: any = items[selectedIndex];
        let inputData = {
            id: item.id
        }
        let apiOptions: any = {
            url: currentContext.deleteImageApi, data: inputData
        };
        http.post(apiOptions).then(response => {
            AlertService.showSuccessMsg("Image deleted successfully");
            getImages();
        });
    }

    const updateDefaultImage = () => {
        let item: any = items[selectedIndex];
        let inputData = {
            id: item.id
        }
        let apiOptions: any = {
            url: currentContext.updateDefaultImageApi, data: inputData
        };
        http.post(apiOptions).then(response => {
            AlertService.showSuccessMsg("Default image updated successfully");
            getImages();
        });
    }

    // const handleChange = (selectedIdx) => {
    //     setSelectedIndex(selectedIdx);
    // }

    useEffect(() => {
        getImages();
    }, []);

    const body = (
        <div className='imageslides-style'>
            <div className="row col-12 title-font py-1 mx-auto">
                <div className="col-11 pl-0">
                    <span>{currentContext.title}</span>
                </div>
                <div className="col-1 text-right pointer px-0" onClick={handleClose}>
                    <HighlightOffIcon fontSize="small" color="secondary" />
                </div>
            </div>

            {items && items.length > 0 &&
                <div className="row m-2">
                    {/* <Carousel onChange={handleChange}>

                        {
                            items && items.map((item: any) => (
                                <div className="text-center">
                                    {item.isDefault == true &&
                                        <div>Default Image</div>
                                    }
                                    <div>
                                        <img src={item.imageUrl} alt="image"></img>
                                    </div>

                                </div>
                            ))}
                    </Carousel> */}
                    <Carousel onChange={handleChange}>
  {items && items.map((item: any, idx: number) => (
    <div className="text-center" key={item.id ?? idx}>
      <div className="zoom-stage" style={{ width: '100%', height: 'calc(60vh)' }}>
  <TransformWrapper
    ref={idx === selectedIndex ? zoomRef : undefined}
    initialScale={1}
    minScale={0.5}
    maxScale={6}
    doubleClick={{ mode: 'zoomIn' }}
    wheel={{ step: 0.15 }}
    pinch={{ step: 5 }}
    panning={{ velocityDisabled: true }}
  >
    {({ zoomIn, zoomOut, resetTransform }) => (
  <>
    {/* Small floating toolbar */}
    <div className="zoom-toolbar">
      <button onClick={() => zoomOut()} className="zoom-btn">−</button>
      <button onClick={() => zoomIn()} className="zoom-btn">+</button>
      <button onClick={() => resetTransform()} className="zoom-btn">Reset</button>
      {/* <button onClick={() => centerView()} className="zoom-btn">Center</button> */}
    </div>
    {/* ...keep rest of zoomable image code here... */}

    <TransformComponent
      wrapperStyle={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        cursor: 'grab',
        background: 'rgba(0,0,0,0.85)'
      }}
      contentStyle={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src={item.imageUrl}
        alt="image"
        draggable={false}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          userSelect: 'none',
          pointerEvents: 'auto'
        }}
      />
    </TransformComponent>
      </>
)}

  </TransformWrapper>
  
</div>
      </div>
    
  ))}
</Carousel>
                </div>
            }

            {items && items.length == 0 &&
                <div className="row m-2 slidewidth">No images found</div>
            }


            {items && items.length > 0 &&
                <div className="row m-2">
                    {currentContext.deleteImageApi &&
                        <div className="col-4">
                            <Button variant="contained" size="small" color="primary" onClick={deleteImage}>
                                Delete
                            </Button>
                        </div>
                    }

                    {currentContext.updateDefaultImageApi &&
                        <div className="col-8">
                            <span className="float-right">
                                <Button variant="contained" size="small" color="primary" onClick={updateDefaultImage}>
                                    Set as Default
                                </Button>
                            </span>
                        </div>
                    }

                </div>
            }

        </div>
    );


    return (
        <div>
            {body}
        </div>
    );

}
export default ImageSlides;
